<template>
  <header id="main-header" class="warmus">
    <BypassLinks />
    <div class="header">
      <a :href="logoMeta[curLang].href" class="main-logo" :class="subClasses" :title="logoMeta[curLang].title">
        <img :src="logoImage" width="303" height="44" :alt="logoMeta[curLang].alt" />
      </a>
      <a href="#mh" id="main-menu-handle" @click.prevent="menuToggle($event)">
        <span class="text-val">{{ menuHandleText[curLang] }}</span>
        <span class="handle-bars-icon">
          <b class="bar"></b>
          <b class="bar"></b>
          <b class="bar"></b>
        </span>
      </a>
    </div>
    <!-- *** -->
    <nav id="main-menu">
      <ul>
        <li v-for="(menuItem, index) in menuItems[curLang]" :key="index">
          <a :id="menuItem.id" :href="menuItem.link">{{ menuItem.text }}</a>
        </li>
      </ul>
    </nav>
  </header>
</template>
<script>
import BypassLinks from './BypassLinks.vue';
export default {
  components: {
    BypassLinks
  },
  data() {
    return {
      curLang: this.$store.getters.getAppLang,
      logoMeta: {
        fr: {
          href: 'https://www.museedelaguerre.ca',
          title: 'Allez à la page d\'accueil',
          alt: 'Logo du Musée canadien de la guerre'
        },
        en: {
          href: 'https://www.warmuseum.ca',
          title: 'Go to the Home page',
          alt: 'Logo of the Canadian War Museum'
        }
      },
      menuHandleText: { en: 'Main Menu', fr: 'Menu principale' },
      menuItems: {
        // Todo: Expose and then ingest main menu as was done for main footer.
        fr: [
          { link: 'https://www.museedelaguerre.ca/visiter/', text: 'Visiter' },
          { link: 'https://www.museedelaguerre.ca/expositions/', text: 'Expositions' },
          { link: 'https://www.museedelaguerre.ca/apprendre/', text: 'Apprendre' },
          { link: 'https://www.museedelaguerre.ca/appuyer/', text: 'Appuyer' },
          { link: 'https://www.museedelaguerre.ca/a-propos/', text: 'À propos' },
          { link: 'https://www.museedelaguerre.ca/magasiner/', text: 'Magasiner' },
          { link: this.appUrl('en'), text: 'English', id: 'language-toggle' }
        ],
        en: [
          { link: 'https://www.warmuseum.ca/visit/', text: 'Visit' },
          { link: 'https://www.warmuseum.ca/exhibitions/', text: 'Exhibitions' },
          { link: 'https://www.warmuseum.ca/learn/', text: 'Learn' },
          { link: 'https://www.warmuseum.ca/shop/', text: 'Shop' },
          { link: 'https://www.warmuseum.ca/support/', text: 'Support' },
          { link: 'https://www.warmuseum.ca/about/', text: 'About' },
          { link: this.appUrl('fr'), text: 'Français', id: 'language-toggle' }
        ]
      }
    };
  },
  computed: {
    logoImage() {
      return require(`@/assets/images/cwm-logo-${this.curLang}@legacy.svg`);
    },
    subClasses() {
      const curLang = this.curLang;
      const baseClass = 'main-logo-wargue';
      const localeClass = `${baseClass}-${curLang}`;
      const classes = baseClass + ' ' + localeClass;
      return classes;
    }
  },
  methods: {
    appUrl(lang) {
      const frUrl = process.env.VUE_APP_URL_FR;
      const enUrl = process.env.VUE_APP_URL_EN;
      return lang === 'fr' ? frUrl : enUrl;
    },
    menuToggle(e) {
      const menuHandle = document.getElementById('main-menu-handle');
      const menuList = document.querySelector('#main-menu ul');
      menuHandle.classList.toggle('icon-close');
      menuList.classList.toggle('visible');
    }
  }
};
</script>